export const supportFormMode = {
    EDITOR: 'editor',
    SUCCESS: 'success',
}

export const supportPopupPositionStrategy = {
    CENTER: 'center',
    FROM_TOP_LEFT: 'fromTopLeft',
    FROM_BOTTOM_RIGHT: 'fromBottomRight',
}

export const supportPopupOffsets = {
    LEFT: 32,
    TOP: -30,
}

export const NO_DRAG_CLASS = 'noDragClass'
export const SUPPORT_NUMBER_ALLOWED_CHARACTERS = 32000
export const SUPPORT_INPUT_HEIGHT = 125
export const SUPPORT_EMAIL_NUMBER_ALLOWED_CHARACTERS = 255


// WEBPACK FOOTER //
// ./web/js/support/supportForm/constants.js